import { render, staticRenderFns } from "./ViewArticleResources.vue?vue&type=template&id=e7940570&scoped=true&"
import script from "./ViewArticleResources.vue?vue&type=script&lang=js&"
export * from "./ViewArticleResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7940570",
  null
  
)

export default component.exports